import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { IC_Template } from 'src/app/Interface/IC_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ICService } from 'src/app/Service/IC/IC.service';
import { Jalali } from 'jalali-ts';

@Component({ selector: 'app-ic-assignment-add', templateUrl: './ICAssignmentAdd.component.html', styleUrls: ['./ICAssignmentAdd.component.css'] })
export class ICAssignmentAddComponent implements OnInit {
  templates: IC_Template[] = [];
  selectedDeviceBehfa: DeviceBehfa_Interface[] = [];
  loading = false;
  saving = false;
  form: FormGroup = this.fb.group({ templateId: [null, Validators.required], dateStart: ['', Validators.required] });
  constructor(private fb: FormBuilder, private service: ICService, private router: Router, private alert: AlertifyService) {}
  ngOnInit(): void {
    this.loading = true;
    this.service.getTemplates(undefined, true).pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: templates => this.templates = (templates || []).filter(template => (template.itemCount ?? 0) > 0),
      error: () => this.alert.ErrorMessage('دریافت الگوها ناموفق بود.')
    });
  }
  setSelectedDevice(item: DeviceBehfa_Interface): void {
    if (!this.selectedDeviceBehfa.some(x => x.id === item.id)) this.selectedDeviceBehfa.push(item);
  }
  removeSelectedDevice(item: DeviceBehfa_Interface): void { this.selectedDeviceBehfa = this.selectedDeviceBehfa.filter(x => x.id !== item.id); }
  save(dateStart: string): void {
    if (this.saving) return;
    this.form.get('dateStart')?.setValue((dateStart || '').trim());
    if (this.form.invalid) { this.form.markAllAsTouched(); return; }
    if (!this.selectedDeviceBehfa.length) { this.alert.ErrorMessage('حداقل یک تجهیز را انتخاب کنید.'); return; }
    let gregorian: string;
    try {
      const entered = String(this.form.value.dateStart).replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 0x06F0))
        .replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 0x0660)).replace(/\//g, '-');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(entered)) throw new Error('Invalid date');
      const date = Jalali.parse(entered);
      if (date.format('YYYY-MM-DD') !== entered) throw new Error('Invalid date');
      gregorian = date.gregorian('YYYY-MM-DD');
    } catch { this.alert.ErrorMessage('تاریخ شروع شمسی معتبر نیست.'); return; }
    this.saving = true;
    this.service.saveAssignment({ iC_Template_ID: Number(this.form.value.templateId), deviceBehfa_IDs: this.selectedDeviceBehfa.map(x => x.id), date_Start: gregorian })
      .pipe(finalize(() => this.saving = false)).subscribe({
        next: () => { this.alert.SuccessMessage('تخصیص با موفقیت ثبت شد.'); this.router.navigate(['/ic/assignment']); },
        error: e => this.alert.ErrorMessage(e?.error?.message || 'ثبت تخصیص ناموفق بود.')
      });
  }
  cancel(): void { this.router.navigate(['/ic/assignment']); }
}
